require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-job-opportunities.json") })
        }
      }, "path---es-job-opportunities");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-job-opportunities!./.cache/json/es-job-opportunities.json
// module id = 1095
// module chunks = 231608221292675